<template>
  <div>
    <h3 class="article_title">{{$t('aboutUs.sectionRegistrationAgreement')}}</h3>

    <div class="article_content" v-html="data"></div>
    <!---->

    <!--                    -->
  </div>
</template>

<script>
    export default {
        name: "helpagreement",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/app/Protocol/protocol",
              method: "post",
              data: {
                'type': 1,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.status == 200) {
              that.data = resData.data.content;
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
.article_title {
  padding: 20px;
  border-radius: 15px;
  background-color: #ffffff;
}
.article_content {
  background-color: #ffffff;
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
}
.article_content >>> img {
  width: 100% !important;
}
</style>




// WEBPACK FOOTER //
// src/components/helpagreement.vue